// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3JqQU","label":"Category_label__129nh","content":"Category_content__2zZTZ","header":"Category_header__2eATj","location":"Category_location__3fdbs"};